import { languages } from "@src/locales/index.js";
import VueI18n from "vue-i18n";
import Vue from "vue";

Vue.use(VueI18n);

const initialState = JSON.parse(
    localStorage.getItem("@datadrive:initialState")
);
const domainData = JSON.parse(localStorage.getItem("@datadrive:domain"));
let lang = "pt";
if (initialState) {
    lang = initialState.languageCode;
} else {
    if (domainData) {
        lang = domainData.languageCode;
    }
}

export default new VueI18n({
    locale: lang,
    fallbackLocale: lang,
    messages: languages,
});
